import { CHANGE_UPLOAD_STATUS, ADD_UPLOAD_ITEM, CLEAR_UPLOAD } from '../constants/ActionTypes';

// 更改上传状态
function getChangeUploadStatusAction(payload) {
  return {
    type: CHANGE_UPLOAD_STATUS,
    payload
  }
}
function getAddUploadItemAction(payload) {
  return {
    type: ADD_UPLOAD_ITEM,
    payload
  }
}
function getClearUploadListAction() {
  return {
    type: CLEAR_UPLOAD
  }
}
export default {
  getChangeUploadStatusAction,
  getAddUploadItemAction,
  getClearUploadListAction
}
